module.exports = __webpack_public_path__ + "img/not-found-dark.d0eb3c79.svg";